import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { Outlet } from "react-router-dom";
import { TopBar } from "./app/TopBar";
import { SideDrawer } from "./app/SideDrawer";
import { useWindowSize } from "../helpers/generic";
import { useEffect, useState } from "react";
import PasswordResetBanner from "./auth/PasswordResetBanner";
import { NewOrderAlert } from "./order/NewOrderAlert";

export const drawerWidth = 199;
export const collapsedDrawerWidth = 72;
const topBarHeight = 64;
export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: topBarHeight, //`${topBarHeight - topBarPadding}px`,
  // padding: theme.spacing(0, 1),
  // ...theme.mixins.toolbar,
}));

export default function MiniDrawer() {
  const isMobile = useWindowSize().width < 957;
  const [open, setOpen] = useState(!isMobile);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
      }}
    >
      <CssBaseline />
      <TopBar open={open} handleDrawerOpen={handleDrawerOpen} />
      <SideDrawer open={open} handleDrawerClose={handleDrawerClose} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          minHeight: "100vh",
          color: "#f0ece8",
          backgroundColor: "#0d0a0b",
          p: isMobile ? "20px" : "28px 32px",
        }}
      >
        <DrawerHeader />
        <PasswordResetBanner />
        <NewOrderAlert />
        <Outlet />
      </Box>
    </Box>
  );
}
